import ctl from '@netlify/classnames-template-literals';

export const containerStyle = ctl(`
  flex
  items-center
  relative
  px-2
  gap-2
  rounded-md
  border-chinese-red
  focus:border-chinese-red 
  active:border-chinese-red
  outline-none
  text-white
  font-semibold
  bg-gunmetal
  w-56
`);

export const previewTextStyle = ctl(`
  text-sm
  cursor-default
`);

export const iconStyle = ctl(`
  text-md
  cursor-pointer
  hover:bg-violet-600 
  active:bg-violet-700
  transition duration-300 ease-in-out
`);

export const iconsContainerStyle = ctl(`
  flex
  items-center
  gap-4
`);

export const messageStyle = ctl(``);
